import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Observable, Subscription } from 'rxjs';

import {
  deleteInformativePage,
  setSelectedInformativePage,
} from 'src/app/dashboard/state/informative-page/informative-page.actions';
import { selectSelectedStudy } from 'src/app/dashboard/state/study/study.selectors';
import {
  selectInformativePages,
  selectSelectedInformativePage,
} from 'src/app/dashboard/state/informative-page/informative-page.selectors';
import { AppState } from 'src/app/state';
import { Study } from 'src/app/models/study';
import { Language } from 'src/app/models/language';
import { StudyType } from 'src/app/models/study-type';
import { InformativePage } from 'src/app/models/informative-page';

@Component({
  selector: 'dashboard-informative-pages-template',
  templateUrl: './informative-pages-template.component.html',
  styleUrls: ['./informative-pages-template.component.scss'],
})
export class InformativePagesTemplateComponent implements OnInit, OnDestroy {
  @Input() selectedLanguage: Language;
  @Input() supportedLanguages: Language[];

  informativePages$: Observable<InformativePage[]>;
  informativePages: InformativePage[];

  infoPages: InformativePage[];
  thanksPages: InformativePage[];

  selectedInformativePage$: Observable<InformativePage>;
  selectedInformativePage: InformativePage;

  selectedStudy$: Observable<Study>;
  selectedStudy: Study;
  StudyType = StudyType;

  isSinglePageVisible = false;

  private subscriptions$ = new Subscription();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.informativePages$ = this.store.select(selectInformativePages);
    this.subscriptions$.add(
      this.informativePages$.subscribe((informativePages) => {
        if (informativePages) {
          this.informativePages = informativePages;
          this.infoPages = this.informativePages.filter((informativePage) => informativePage?.isThanks === 0);
          this.thanksPages = this.informativePages.filter((informativePage) => informativePage?.isThanks === 1);
        }
      })
    );

    this.selectedInformativePage$ = this.store.select(selectSelectedInformativePage);
    this.subscriptions$.add(
      this.selectedInformativePage$.subscribe((informativePage) => {
        this.selectedInformativePage = informativePage;
      })
    );

    this.selectedStudy$ = this.store.select(selectSelectedStudy);
    this.subscriptions$.add(this.selectedStudy$.subscribe((selectedStudy) => (this.selectedStudy = selectedStudy)));
  }

  toggleSinglePageVisibility(): void {
    this.isSinglePageVisible = !this.isSinglePageVisible;
  }

  onSelect(informativePage: InformativePage): void {
    this.store.dispatch(setSelectedInformativePage({ selectedInformativePage: informativePage }));
  }

  onBack(): void {
    this.store.dispatch(setSelectedInformativePage({ selectedInformativePage: null }));
  }

  onDelete(informativePage): void {
    const pageDetails = {
      ...informativePage,
      studyId: this.selectedStudy?.id,
    };
    this.store.dispatch(deleteInformativePage({ informativePage: pageDetails }));
  }

  afterSave(): void {
    this.toggleSinglePageVisibility();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
